import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  CustomDialog,
  FormsAddUnite,
  ModalCorrespondanceUnite,
  showToast,
} from "..";
import { unitesOrganisationSerivces } from "../../services";
import { Actif, UniteOrganisation } from "../../interfaces";
import { useQueryClient } from "@tanstack/react-query";

interface ModalAddUniteProps {
  modalIsOpenUnité: boolean;
  closeModalUnité: () => void;
  actif?: Actif;
  unités?: UniteOrganisation[];
  setUnités?: any;
  setLoading: (newvalue: boolean) => void;
}
const ModalAddUnite = ({
  modalIsOpenUnité,
  closeModalUnité,
  actif,
  unités,
  setUnités,
  setLoading,
}: ModalAddUniteProps) => {
  const queryClient = useQueryClient();
  const [addedUnite, setAddedUnite] = useState<UniteOrganisation | null>(null);
  const [selectedtype, setSelectedType] = useState<string>(null);
  const [modalIsOpenCorrespondance, setIsOpenCorrespondance] =
    useState<boolean>(false);
  const [selectedSousType, setSelectedSousType] = useState<string>("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      if (selectedtype !== null || selectedtype !== "") {
        setLoading(true);
        const UniteData = {
          type_unite: data.type_unite,
          nom_unite: data.nom_unite,

          ...(data.numero_lot !== undefined &&
          data.numero_lot !== ""
            ? { numero_lot: parseInt(data.numero_lot, 10) }
            : {}),
          ...(data.numero_volume !== undefined &&
          data.numero_volume !== ""
            ? { numero_volume: parseInt(data.numero_volume, 10) }
            : {}),
          ...(data.surface_plancher !== undefined &&
          data.surface_plancher !== ""
            ? { surface_plancher: parseInt(data.surface_plancher, 10) }
            : {}),
          ...(data.surface_habitable !== undefined &&
          data.surface_habitable !== ""
            ? { surface_habitable: parseInt(data.surface_habitable, 10) }
            : {}),
          ...(data.sous_type_unite !== undefined && data.sous_type_unite !== ""
            ? { sous_type_unite: data.sous_type_unite }
            : {}),
          ...(data.niveau_unite !== undefined && data.niveau_unite !== ""
            ? { niveau_unite: data.niveau_unite }
            : {}),
        };
        await unitesOrganisationSerivces.post(UniteData).then((response) => {
          setLoading(false);
          showToast("success", "Unité d'organisation ajouté avec succès");
          setAddedUnite(response.data);
          queryClient.refetchQueries({
            queryKey: ["actifs"],
          });

          reset();
          setSelectedType("");
          closeModalUnité();
          openModalCorrespondance();
        });
      } else {
        setLoading(false);
        showToast("warning", "Vous devez choisir un type d'unité");
      }
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  function openModalCorrespondance() {
    setIsOpenCorrespondance(true);
  }
  function closeModalCorrespondance() {
    setIsOpenCorrespondance(false);
  }

  return (
    <>
      <CustomDialog
        header="Ajouter unité d'organisation"
        visible={modalIsOpenUnité}
        closeModalDialog={() => {
          closeModalUnité();
          reset();
          setSelectedType("");
        }}
      >
        <div className="w-full h-full ">
          <div className="p-6 space-y-6">
            <form
              onSubmit={handleSubmit(onSubmit)}
              encType="multipart/form-data"
            >
              <div className="grid grid-cols-6 gap-6">
                <div className="col-span-6 sm:col-span-6">
                  <label
                    htmlFor="type_unite"
                    className="block text-md font-bold leading-6 text-gray-900"
                  >
                    Type *
                  </label>

                  <select
                    name="type_unite"
                    id="type_unite"
                    className="  my-3 border border-gray-300 text-gray-900 font-semibold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                    {...register("type_unite", {
                      required: true,
                    })}
                    onChange={(e) => {
                      setSelectedType(e.target.value);
                    }}
                  >
                    <option value={""}>Choisir votre type</option>
                    <option value={"CLASSE"}>Classe</option>
                    <option value={"COPROPRIETE"}>Copropriété</option>
                    <option value={"LOCATIVE"}>Locative</option>
                    <option value={"OCCUPATION"}>Occupation</option>
                    <option value={"VOLUMETRIQUE"} >
                      Volumétrique
                    </option>
                    <option value={"ORGANISATION"}>Organisation</option>
                  </select>
                  {errors.type_unité && (
                    <span className="bg-red-100 text-red-800 text-md font-medium mr-2 mt-2 px-2.5 py-0.5 rounded ">
                      champs obligatoire
                    </span>
                  )}
                </div>
                <FormsAddUnite
                  register={register}
                  selectedtype={selectedtype}
                  errors={errors}
                  setSelectedSousType={setSelectedSousType}
                />
              </div>
              <p className=" text-lg font-thin my-4">* obligatoire</p>

              <div className="flex justify-end space-x-2 mt-5">
                <button
                  type="submit"
                  className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-md px-6 py-3  text-center "
                >
                  Suivant
                </button>
                <button
                  type="button"
                  onClick={() => {
                    closeModalUnité();
                    setSelectedType("");
                  }}
                  className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-3  text-center "
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        </div>
      </CustomDialog>
      <ModalCorrespondanceUnite
        closeModalCorrespondance={closeModalCorrespondance}
        modalIsOpenCorrespondance={modalIsOpenCorrespondance}
        unite={addedUnite}
        actif={actif}
        unités={unités}
        setUnités={setUnités}
        setLoading={setLoading}
      />
    </>
  );
};

export default ModalAddUnite;
